<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Power</h4>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-8">
        <div class="alert alert-danger" role="alert" v-if="machine_type === 'Box'">
          <b>Warning:</b> You will need physical access to the machine to power back on.
        </div>
        <form>
          <div class="form-group row" v-if="machine_type === 'Box'">
            <label class="col-3" for="btnPowerOff">Power Off</label>
            <button type="button" class="btn btn-hub-primary" id="btnPowerOff"
                    @click="executeConsoleCommand('power off')" title="Power off the machine">Power Off
            </button>
          </div>
          <div class="form-group row">
            <label class="col-3" for="btnReboot">Reboot</label>
            <button type="button" class="btn btn-hub-primary" id="btnReboot" @click="executeConsoleCommand('reboot')"
                    title="Reboot the machine">Reboot
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'adminMachinePower',
  computed: mapGetters({
    machine_type: 'machineType'
  }),
  methods: {
    ...mapActions([
      'executeConsoleCommand'
    ])
  }
}
</script>

<style scoped>

</style>
